'use client';

import { useEffect } from 'react';
import { sendToSentry } from '@/utils/sentry';

const SendToSentry = ({ error }: { error: Error & { digest?: string } }) => {
  useEffect(() => {
    sendToSentry(error, null, 'error-boundary', 'app-page', {
      digest: error.digest,
    });
  }, [error]);
  return null;
};

export default SendToSentry;
